/**
 * @generated SignedSource<<f74b5165f68392047c1d855a3c2c6fdc>>
 * @relayHash 4436acfa17b4dbd15b493323874fcc83
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc3bfbe6780886c7071a6a07b299ee0703e250c5a88271c2c70c96747550668b

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildMembersOrganizersSectionPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  id: string;
};
export type GuildMembersOrganizersSectionPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"GuildMembersOrganizersSection_guild">;
  } | null | undefined;
};
export type GuildMembersOrganizersSectionPaginationQuery = {
  response: GuildMembersOrganizersSectionPaginationQuery$data;
  variables: GuildMembersOrganizersSectionPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 3,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v7 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v8 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v9 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v10 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membershipLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "transform"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildMembersOrganizersSectionPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              }
            ],
            "kind": "FragmentSpread",
            "name": "GuildMembersOrganizersSection_guild"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildMembersOrganizersSectionPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "organizers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UsersEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bio",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMe",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emailMd5",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "primaryPhoto",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "fields": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "Literal",
                                        "name": "fo",
                                        "value": "face"
                                      },
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "transform"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "transformUrl",
                                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "fields": [
                                  (v7/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "kind": "ObjectValue",
                                "name": "transform"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "defaultAvatarUrl",
                            "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "backgroundPhoto",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "transform",
                                    "value": {
                                      "dpr": 3,
                                      "fit": "cover",
                                      "h": 167,
                                      "w": 500
                                    }
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "transformUrl",
                                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":167,\"w\":500})"
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "organizerGuildMemberships",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "condition",
                                "value": {
                                  "membershipLevel": "ORGANIZER"
                                }
                              },
                              (v11/*: any*/)
                            ],
                            "concreteType": "GuildMembershipsConnection",
                            "kind": "LinkedField",
                            "name": "guildMemberships",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
                          },
                          {
                            "alias": "editorGuildMemberships",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "condition",
                                "value": {
                                  "membershipLevel": "EDITOR"
                                }
                              },
                              (v11/*: any*/)
                            ],
                            "concreteType": "GuildMembershipsConnection",
                            "kind": "LinkedField",
                            "name": "guildMemberships",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
                          },
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersOrganizersSection_guild_organizers",
                "kind": "LinkedHandle",
                "name": "organizers"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "bc3bfbe6780886c7071a6a07b299ee0703e250c5a88271c2c70c96747550668b",
    "metadata": {},
    "name": "GuildMembersOrganizersSectionPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "845ddb78e4858be4a7ba64e181965db5";

export default node;
